import React from "react";
import "./verify.css";
import { useForm, Controller } from "react-hook-form";

const Verify = ({ otpVerify, handleResendOtp }) => {
  const { control, handleSubmit } = useForm();

  const handleVerify = (data) => {
    otpVerify(data.otpverify);
  };

  return (
    <div className="verify-container">
      <h2>PHONE NUMBER VERIFICATION</h2>

      <form onSubmit={handleSubmit(handleVerify)}>
        <div>
          <label>Please enter the code sent to your Whatsapp</label>

          <Controller
            name="otpverify"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <input
                type="text"
            className="otp-box"

                {...field}
                placeholder="VERIFICATION CODE"
              />
            )}
          />
        </div>

        <button className="verify-btn" type="submit">
          Verify
        </button>

        <button
          type="button"
          className="verify-btn"
          onClick={handleResendOtp}
        >
          Resend OTP
        </button>
      </form>
    </div>
  );
};

export default Verify;